import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Themes from './Helpers/Themes';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import Loaders from './Components/Loader';
import { PrivateRoute } from './Components/PrivateRoute';
import { PublicRoute } from './Components/PublicRoute';
import { SnackbarProvider } from 'notistack';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useMediaQuery } from '@mui/material';
import { pdfjs } from 'react-pdf';

const DashBoard = React.lazy(() => import('./Application/DashBoard/index'));
const StartUps = React.lazy(() => import('./Application/Startup/index'));
const Login = React.lazy(() => import('./Application/Login/index'));
const OtpVerify = React.lazy(() => import('./Application/OtpVerify'));
const Schedules = React.lazy(() => import('./Application/Schedules'));
const AssignedStartups = React.lazy(() => import('./Application/AssignedStartups'));
const Notes = React.lazy(() => import('./Application/MobileNotes'));
const Notifications = React.lazy(() => import("./Components/Notification"));

const App: React.FunctionComponent = () => {
  const query = new QueryClient();
  const isMobile = useMediaQuery('(max-width:600px)');
  pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

  return (
    <QueryClientProvider client={query}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Themes>
          <SnackbarProvider
            anchorOrigin={{
              horizontal: isMobile ? 'center' : 'left',
              vertical: isMobile ? 'top' : 'bottom',
            }}
            autoHideDuration={5000}
          >
            <React.Suspense fallback={<Loaders />}>
              <Routes>
                <Route
                  path="/"
                  index
                  element={
                    <PublicRoute>
                      <Login />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/login-verify"
                  element={
                    <PublicRoute>
                      <OtpVerify />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/home"
                  element={
                    <PrivateRoute>
                      <DashBoard />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/startup-profile/:id"
                  element={
                    <PrivateRoute>
                      <StartUps />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/startups"
                  element={
                    <PrivateRoute>
                      <AssignedStartups />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/schedules"
                  element={
                    <PrivateRoute>
                      <Schedules />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/notes/:id"
                  element={
                    <PrivateRoute>
                      <Notes />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/notification"
                  element={
                    <PrivateRoute>
                      <Notifications />
                    </PrivateRoute>
                  }
                />
              </Routes>
            </React.Suspense>
          </SnackbarProvider>
        </Themes>
      </LocalizationProvider>
    </QueryClientProvider>
  );
};

export default App;
